import { error, misc, success } from "app/themes/colors";
import EnumDataSource from "utils/enum-data-source.util";

export const MESSAGE_TYPE_NOTIFICATION = 1;
export const MESSAGE_TYPE_REMINDER_REQUEST = 2;
export const MESSAGE_TYPE_REMINDER_RESPONSE = 3;
export const MESSAGE_TYPE_REMINDER_ACKNOWLEDGMENT = 4;
export const MESSAGE_TYPE_APPOINTMENT_INFORMATION = 5;
export const MESSAGE_TYPE_TEXTING = 6;
export const MESSAGE_TYPE_PRIVATE_FEEDBACK_REQUEST = 7;
export const MESSAGE_TYPE_PRIVATE_FEEDBACK_RESPONSE = 8;
export const MESSAGE_TYPE_PRIVATE_FEEDBACK_TEXTUAL_REQUEST = 9;
export const MESSAGE_TYPE_PRIVATE_FEEDBACK_TEXTUAL_RESPONSE = 10;
export const MESSAGE_TYPE_GOOGLE_REVIEW_FEEDBACK_REQUEST = 11;
export const MESSAGE_TYPE_RESCHEDULE = 12;
export const MESSAGE_TYPE_INTAKE_FORM_REQUEST = 13;
export const MESSAGE_TYPE_INTAKE_FORM_REQUEST_REMINDER = 14;

export const MESSAGE_TYPES = new EnumDataSource({
  [MESSAGE_TYPE_NOTIFICATION]: "Notification",
  [MESSAGE_TYPE_REMINDER_REQUEST]: "Reminder Request",
  [MESSAGE_TYPE_REMINDER_RESPONSE]: "Reminder Response",
  [MESSAGE_TYPE_REMINDER_ACKNOWLEDGMENT]: "Reminder Acknowledgment",
  [MESSAGE_TYPE_APPOINTMENT_INFORMATION]: "Appointment Information",
  [MESSAGE_TYPE_TEXTING]: "Texting",
  [MESSAGE_TYPE_PRIVATE_FEEDBACK_REQUEST]: "Private Feedback Request",
  [MESSAGE_TYPE_PRIVATE_FEEDBACK_RESPONSE]: "Private Feedback Response",
  [MESSAGE_TYPE_PRIVATE_FEEDBACK_TEXTUAL_REQUEST]:
    "Private Feedback Textual Request",
  [MESSAGE_TYPE_PRIVATE_FEEDBACK_TEXTUAL_RESPONSE]:
    "Private Feedback Textual Response",
  [MESSAGE_TYPE_GOOGLE_REVIEW_FEEDBACK_REQUEST]:
    "Google Review Feedback Request",
  [MESSAGE_TYPE_RESCHEDULE]: "Reschedule",
  [MESSAGE_TYPE_INTAKE_FORM_REQUEST]: "Intake Form Request",
  [MESSAGE_TYPE_INTAKE_FORM_REQUEST_REMINDER]: "Intake Form Request Reminder"
});

export const TOUCHPOINT_OUTCOME_UNKNOWN = 1;
export const TOUCHPOINT_OUTCOME_SUCCESSFUL = 2;
export const TOUCHPOINT_OUTCOME_UNSUCCESSFUL = 3;

export const TOUCHPOINT_OUTCOMES = new EnumDataSource({
  [TOUCHPOINT_OUTCOME_UNKNOWN]: "Unknown",
  [TOUCHPOINT_OUTCOME_SUCCESSFUL]: "Successful",
  [TOUCHPOINT_OUTCOME_UNSUCCESSFUL]: "Unsuccessful"
});

export const TOUCHPOINT_TYPE_AUTOMATED = 1;
export const TOUCHPOINT_TYPE_MANUAL = 2;
export const TOUCHPOINT_TYPE_BULK = 3;

export const TOUCHPOINT_TYPES = new EnumDataSource({
  [TOUCHPOINT_TYPE_AUTOMATED]: "Automated",
  [TOUCHPOINT_TYPE_MANUAL]: "Manual"
});

export const TOUCHPOINT_STATUS_UPCOMING = 1;
export const TOUCHPOINT_STATUS_COMPLETE = 2;
export const TOUCHPOINT_STATUS_CANCELLED = 3;
export const TOUCHPOINT_STATUS_OBSOLETE = 4;
export const TOUCHPOINT_STATUS_FAILED = 5;

export const TOUCHPOINT_STATUSES = new EnumDataSource({
  [TOUCHPOINT_STATUS_UPCOMING]: "Upcoming",
  [TOUCHPOINT_STATUS_COMPLETE]: "Complete",
  [TOUCHPOINT_STATUS_CANCELLED]: "Cancelled",
  [TOUCHPOINT_STATUS_FAILED]: "Failed"
});

export const TOUCHPOINT_STATUS_COLORS: Record<number, string> = {
  [TOUCHPOINT_STATUS_CANCELLED]: misc.grayAsphalt,
  [TOUCHPOINT_STATUS_FAILED]: error[400],
  [TOUCHPOINT_STATUS_UPCOMING]: misc.darkYellow,
  [TOUCHPOINT_STATUS_COMPLETE]: success[600]
};

export const TOUCHPOINT_ALL_STATUSES_KEY =
  `${TOUCHPOINT_STATUS_UPCOMING},${TOUCHPOINT_STATUS_COMPLETE},${TOUCHPOINT_STATUS_CANCELLED},${TOUCHPOINT_STATUS_FAILED}` as const;
